import {
  ServicosInfoJson,
  components as componentsServicos,
  imagensDesk as imagensDeskServicos,
  imagensMob as imagensMobServicos,
} from '../../config/configServicos';
import { viaturasConfig } from '../../config/configViaturas';
import { SelectTiposViatura, createLinkPesquisa } from './tratarInfoCarros';

const ArrayServicosInfoJson = (infoJson, allinfoText) => {
  const createServicos = Object.keys(infoJson)
    .filter(key => ServicosInfoJson.includes(key))
    .reduce((obj, key) => {
      const DynamicComponent = componentsServicos[key];
      const dynamicImgDesk = imagensDeskServicos[key];
      const dynamicimgMob = imagensMobServicos[key];

      const calculatedIcon = allinfoText[key]?.icon === true ? true : !!infoJson[key]?.icon;

      obj[key] = {
        ...infoJson[key],
        icon: calculatedIcon,
        existe:
          allinfoText[key] &&
          allinfoText[key].existe !== undefined &&
          allinfoText[key].existe !== null
            ? allinfoText[key].existe
            : infoJson[key].existe,
        titulo:
          allinfoText[key] &&
          allinfoText[key].Titulo !== undefined &&
          allinfoText[key].Titulo !== null
            ? allinfoText[key].Titulo
            : infoJson[key].titulo,
        url:
          allinfoText[key] && allinfoText[key].Url !== undefined && allinfoText[key].Url !== null
            ? allinfoText[key].Url
            : infoJson[key].url,
        texto:
          allinfoText[key] && allinfoText[key].Zona !== undefined && allinfoText[key].Zona !== null
            ? allinfoText[key].Zona
            : '',
        imgDesk: dynamicImgDesk,
        imgMob: dynamicimgMob,
        Svg: <DynamicComponent />,
      };

      return obj;
    }, {});

  const arrServicos = Object.values(createServicos).sort((a, b) => {
    if (a.ordenar && b.ordenar) {
      return a.ordenar - b.ordenar;
    }
    return true;
  });

  return arrServicos;
};

export const createObjectViaturas = infoJson =>
  Object.keys(viaturasConfig).reduce((obj, key) => {
    obj[key] = {
      ...viaturasConfig[key],
      ...(infoJson.Layout.Carros.tipoViaturas && infoJson.Layout.Carros.tipoViaturas[key]),
    };
    return obj;
  }, {});

const ArrayViaturasInfoJson = (infoJson, state) => {
  //ciar objecto com as viaturas do info json e as por defeito
  const tipoViaturas = createObjectViaturas(infoJson);

  //criar novo objecto que para listar em todas a zonas

  const createViaturas = Object.keys(tipoViaturas).reduce((obj, key) => {
    const DynamicComponent = tipoViaturas[key].svg;
    obj[key] = {
      ...tipoViaturas[key],
      titulo: tipoViaturas[key].titulo,
      Svg: <DynamicComponent />,
      url: createLinkPesquisa(state, infoJson, key, 1),
      array: state[tipoViaturas[key].state],
      existe: state[tipoViaturas[key].state].length !== 0 ? true : false,
      tipo: createLinkPesquisa(state, infoJson, key, 2),
      tipoViatura: SelectTiposViatura(key),
      name: key,
    };

    return obj;
  }, {});

  const arrViaturas = Object.values(createViaturas).sort((a, b) => {
    if (a.ordenar && b.ordenar) {
      return a.ordenar - b.ordenar;
    }
    return true;
  });

  return arrViaturas;
};

const selectSegmentos = (infoJson, array, dispatch) => {
  const tipoViaturas = createObjectViaturas(infoJson);

  const filtrosEspeciais = {
    automoveis: viatura =>
      viatura.categoriaListagem.includes('automoveis') && viatura.categoriaListagem.length === 1,
    motas: viatura =>
      viatura.categoriaListagem.includes('motas') && viatura.categoriaListagem.length === 2,
    barcos: viatura =>
      viatura.categoriaListagem.includes('barcos') && viatura.categoriaListagem.length === 2,
    vendidos: viatura => viatura.categoriaListagem.includes('vendidos'),
    classicos: viatura => viatura.categoriaListagem.includes('classicos'),
    campanhas: viatura => viatura.categoriaListagem.includes('campanhas'),
    retomas: viatura => viatura.categoriaListagem.includes('retomas'),
    novos: viatura => viatura.categoriaListagem.includes('novos'),
  };

  // Para garantir exclusão de categorias prioritárias
  const isBlockedCategoria = (viatura, tipoViaturas) => {
    const bloqueadas = ['classicos', 'vendidos', 'campanhas', 'retomas', 'novos'];
    for (const cat of bloqueadas) {
      if (tipoViaturas[cat]?.existe && viatura.categoriaListagem.includes(cat)) {
        return true;
      }
    }
    if (
      (tipoViaturas.motas?.existe &&
        viatura.categoriaListagem.includes('motas') &&
        viatura.categoriaListagem.length === 2) ||
      (tipoViaturas.barcos?.existe &&
        viatura.categoriaListagem.includes('barcos') &&
        viatura.categoriaListagem.length === 2)
    ) {
      return true;
    }
    return false;
  };

  Object.keys(viaturasConfig).forEach(key => {
    if (!tipoViaturas[key]?.existe) {
      dispatch({ type: viaturasConfig[key].Dispatch, list: [] });
      return;
    }

    let filtered = [];

    if (filtrosEspeciais[key]) {
      filtered = array.filter(filtrosEspeciais[key]);
    } else {
      filtered = array.filter(
        viatura =>
          viatura.categoriaListagem.includes(key) && !isBlockedCategoria(viatura, tipoViaturas),
      );
    }

    dispatch({
      type: viaturasConfig[key].Dispatch,
      list: filtered,
    });
  });
};

export { ArrayServicosInfoJson, ArrayViaturasInfoJson, selectSegmentos };
